// Winding mountain path for enemies to follow
// Points are [x, y] coordinates on the 900x650 canvas
// Path enters from top-left, winds through the map, exits bottom-right to the lodge

export const PATH_POINTS: [number, number][] = [
  [-30, 100],    // start off-screen
  [100, 100],
  [200, 100],
  [300, 120],
  [380, 180],
  [400, 260],
  [380, 340],
  [300, 380],
  [200, 380],
  [120, 340],
  [100, 280],
  [120, 220],
  [200, 200],
  [300, 220],
  [400, 280],    // center area
  [500, 320],
  [600, 340],
  [700, 300],
  [750, 240],
  [700, 180],
  [620, 150],
  [550, 180],
  [520, 260],
  [560, 360],
  [640, 420],
  [740, 450],
  [790, 480],
  [830, 510],
  [850, 530],    // arrive at lodge door
]

export const PATH_WIDTH = 30
